(function () {
    'use strict';

    run.admin.parts.avatarEditor = function() {
        const csrf_name = document.getElementsByName('csrf_name')[0].value;
        const csrf_value = document.getElementsByName('csrf_value')[0].value;
        const avatarChangeButton = document.getElementById('avatar_change_image');
        let avatarUploadTemplate = document.getElementById('template_upload_avatar').innerHTML;

        avatarChangeButton.addEventListener('click', function(e) {
            Swal.fire({
                title: 'Upload new image',
                html: avatarUploadTemplate,
                showCloseButton: false,
                showCancelButton: true,
                showConfirmButton: true,
                focusCancel: true,
                cancelButtonText: 'Cancel',
                confirmButtonText: 'Upload image',
                buttonsStyling: false,
                reverseButtons: true,
                customClass: {
                    cancelButton: 'btn btn-light',
                    confirmButton: 'btn btn-primary ms-4'
                },
                showClass: {
                    popup: 'animate__animated animated__fast animate__fadeInUp'
                },
                hideClass: {
                    popup: 'animate__animated animated__fast animate__fadeOutDown'
                },
                didOpen: () => {
                    let uploadField = document.getElementById("avatar");
                    uploadField.setAttribute('accept', 'image/*');

                    uploadField.onchange = function() {
                        if (this.files[0].size > 2097152) {
                            alert("File is too big. Please select another image");
                            this.value = "";
                        };
                    };
                }
            }).then((result) => {
                if (result.value) {
                    const csrf_name_field = document.getElementsByName('csrf_name')[0];
                    const csrf_value_field = document.getElementsByName('csrf_value')[0];

                    avatarChangeButton.innerText = 'Uploading ...';
                    avatarChangeButton.setAttribute('disabled', 'disabled');

                    const uploadForm = document.getElementById('avatar_upload');
                    uploadForm.appendChild(csrf_name_field.cloneNode(true));
                    uploadForm.appendChild(csrf_value_field.cloneNode(true));
                    //uploadForm.requestSubmit();

                    var data = new FormData();
                    data.append('csrf_name', csrf_name);
                    data.append('csrf_value', csrf_value);
                    data.append('avatar', document.getElementById('avatar').files[0]);

                    axios.post(GlobalRoutes.avatar.upload, data)
                        .then(function (response) {
                            window.location = GlobalRoutes.profile.edit;
                        })
                        .catch(function (error) {
                            new Toast(error.response.data.error, Toast.TYPE_ERROR, Toast.TIME_NORMAL);
                        });
                }
            });
        });

        document.addEventListener('click',function(e) {
            const deleteButton = document.getElementById('avatar_delete');
            let clicked_save_button = e.target.closest('#avatar_delete');
            if (clicked_save_button) {
                Swal.fire({
                    title: deleteButton.dataset.title,
                    html: deleteButton.dataset.content,
                    showCloseButton: false,
                    showCancelButton: true,
                    showConfirmButton: true,
                    focusCancel: true,
                    cancelButtonText: deleteButton.dataset.cancelButton,
                    confirmButtonText: deleteButton.dataset.confirmButton,
                    buttonsStyling: false,
                    reverseButtons: true,
                    customClass: {
                        cancelButton: 'btn btn-light',
                        confirmButton: 'btn btn-danger ms-4'
                    },
                    showClass: {
                        popup: 'animate__animated animated__fast animate__fadeInUp'
                    },
                    hideClass: {
                        popup: 'animate__animated animated__fast animate__fadeOutDown'
                    }
                }).then((result) => {
                    if (result.value) {
                        window.location.href = deleteButton.dataset.href;
                    }
                });
            }
        });
    };
})();
